import { convertModelToFormData } from './helpers';
import { qportalApi } from './qportal-api';
const addContactPersons = (contactPerson) => {
    const formData = convertModelToFormData(contactPerson);
    return qportalApi.postForm(`contactPerson`, formData);
};
const getContactPersons = () => {
    return qportalApi.get(`contactPerson`);
};
const getContactPersonById = (Id) => {
    return qportalApi.get(`contactPerson/${Id}`);
};
const updateContactPersons = (contactPerson) => {
    const formData = convertModelToFormData(contactPerson);
    return qportalApi.postForm('contactPerson/updateContactPersonAsync', formData);
};
const ContactPersonApi = {
    addContactPersons,
    getContactPersons,
    getContactPersonById,
    updateContactPersons
};
export default ContactPersonApi;
